export const eventNames = {
  openApplication: 'openApplication',
  componentViewed: 'componentViewed',
  addProductToBasket: 'addProductToBasket',
  clickSocialNetwork: 'clickSocialNetwork',
  carouselScrollStop: 'carouselScrollStop',
  productDetailViewed: 'productDetailViewed',
}